module.exports = __webpack_public_path__ + "static/img/news_20.8b63bd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_20.jpg
// module id = /Cqg
// module chunks = 2